import React, { useState, useEffect, useRef } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

const AddRoute = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [companies, setCompanies] = useState([])
  const [plants, setPlants] = useState([])
  const [centers, setCenters] = useState([])
  const [selectedCompany, setSelectedCompany] = useState("")
  const [selectedPlant, setSelectedPlant] = useState("")
  const [loadingCenters, setLoadingCenters] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const [compResp, plantResp] = await Promise.all([
          api.get("companies"),
          api.get("plants")
        ])
        const compData = Array.isArray(compResp.data.data) ? compResp.data.data : compResp.data.data?.data || []
        setCompanies(compData)
        setPlants(Array.isArray(plantResp.data.data) ? plantResp.data.data : plantResp.data.data?.data || [])
        if (compData.length === 1) setSelectedCompany(String(compData[0].id))
      } catch (e) { console.error(e) }
    }
    load()
  }, [])

  // Load chilling centers when plant changes
  useEffect(() => {
    if (!selectedPlant) { setCenters([]); return }
    const loadCenters = async () => {
      setLoadingCenters(true)
      try {
        const resp = await api.get("chillings-by-plant/" + selectedPlant)
        setCenters(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
      } catch (e) { console.error(e) }
      setLoadingCenters(false)
    }
    loadCenters()
  }, [selectedPlant])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      // Build only the data the API needs
      const postData = {
        company: hasMultiCompanies ? values.company : String(companies[0].id),
        chillingCenter: values.chillingCenter,
        routeName: values.routeName,
        routeNumber: values.routeNumber,
      }
      const resp = await api.post("create-route", postData)
      if (resp.data.success) {
        formRef.current.reset()
        setSubmitted(true)
        setSelectedPlant(""); setCenters([])
        setTimeout(() => setSubmitted(false), 4000)
      }
    } catch (error) {
      console.error(error)
      alert(error.response?.data?.message || error.response?.data?.error || "Failed to add route")
    }
    setLoading(false)
  }

  const hasMultiCompanies = companies.length > 1
  const filteredPlants = hasMultiCompanies && selectedCompany
    ? plants.filter(p => String(p.company_id) === selectedCompany)
    : plants

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Add Route</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Link to="/routes" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link>
          </Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm ref={formRef} className="form-horizontal mt-4" onValidSubmit={handleValidSubmit}>

          <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px" }}>
            <i className="fas fa-route"></i> Route Details
          </h6>

          {hasMultiCompanies && (
            <Row>
              <Col md={4}><div className="mb-3">
                <AvField type="select" name="company" label="Company *" required
                  onChange={e => { setSelectedCompany(e.target.value); setSelectedPlant(""); setCenters([]) }}>
                  <option value="">Select Company</option>
                  {companies.map((c, i) => <option key={i} value={String(c.id)}>{c.name}</option>)}
                </AvField>
              </div></Col>
            </Row>
          )}

          <Row>
            <Col md={3}><div className="mb-3">
              <AvField type="select" name="plant_filter" label="Plant *"
                onChange={e => setSelectedPlant(e.target.value)}>
                <option value="">Choose a plant . . .</option>
                {filteredPlants.map((p, i) => <option key={i} value={String(p.id)}>{p.name}</option>)}
              </AvField>
            </div></Col>
            <Col md={3}><div className="mb-3">
              <AvField type="select" name="chillingCenter" label={<>Chilling Center * {loadingCenters && <Spinner size="sm" color="primary" className="ms-1" />}</>} required>
                <option value="">{loadingCenters ? "Loading..." : centers.length ? "Choose a chilling center . . ." : "Select plant first"}</option>
                {centers.map((c, i) => <option key={i} value={String(c.id)}>{c.name}{c.number ? ` (${c.number})` : ""}</option>)}
              </AvField>
            </div></Col>
            <Col md={3}><div className="mb-3">
              <AvField name="routeName" label="Route Name *" type="text" required placeholder="Enter Route Name" />
            </div></Col>
            <Col md={3}><div className="mb-3">
              <AvField name="routeNumber" label="Route Number *" type="text" required placeholder="Enter Route Number" />
            </div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">
              {submitted && <UncontrolledAlert color="success"><strong>Route Added Successfully!</strong></UncontrolledAlert>}
            </div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /><span style={{ paddingLeft: "10px" }}>Adding...</span></> : <span><i className="fas fa-plus-circle"></i> Add Route</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default AddRoute
